import { styled, Theme, CSSObject } from '@mui/material/styles';
import MuiDrawer from '@mui/material/Drawer';

const drawerWidth = 250;

//FUNÇÂO QUE CARREGA A DINÂMICA E ESTILO DO SIDE BAR ABERTO
const openedMixin = (theme: Theme): CSSObject => ({
	width: drawerWidth,
	height: '100vh',
	backgroundColor: '#2f4050',
	transition: theme.transitions.create('width', {
		easing: theme.transitions.easing.sharp,
		duration: theme.transitions.duration.enteringScreen,
	}),
	overflowX: 'hidden',
});

//FUNÇÂO QUE CARREGA A DINÂMICA E ESTILO DO SIDE BAR FECHADO
const closedMixin = (theme: Theme): CSSObject => ({
	backgroundColor: '#2f4050',
	transition: theme.transitions.create('width', {
		easing: theme.transitions.easing.sharp,
		duration: theme.transitions.duration.leavingScreen,
	}),
	overflowX: 'hidden',
	width: `calc(${theme.spacing(7)} + 1px)`,
	[theme.breakpoints.up('sm')]: {
		width: `calc(${theme.spacing(8)} + 1px)`,
	},
});

const Drawer = styled(MuiDrawer, { shouldForwardProp: (prop) => prop !== 'open' })(
	({ theme, open }) => ({
		width: drawerWidth,
		flexShrink: 0,
		display: 'block',
		whiteSpace: 'nowrap',
		boxSizing: 'border-box',
		...(open && {
			...openedMixin(theme),
			'& .MuiDrawer-paper': openedMixin(theme),
		}),
		...(!open && {
			...closedMixin(theme),
			'& .MuiDrawer-paper': closedMixin(theme),
		}),
	}),
);

export const DrawerHeader = styled('div')(({ theme }) => ({
	display: 'block',
	padding: 5,
	backgroundColor: '#2f4050;',
	marginLeft: 2,
	...theme.mixins.toolbar,
}));

export default Drawer